import { GetterTree } from 'vuex';
import { URLState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { URLObjectGetter } from './getters/url.getter';

export const URL_GETTERS: GetterTree<URLState, RootStoreState> = {
  ...new URLObjectGetter().getters
};
